import _TagInput from './TagInput';

import './style/index.js';

export type { TagInputProps } from './TagInput';
export * from './type';

export const TagInput = _TagInput;
export default TagInput;
